export var DateRange;
(function (DateRange) {
    DateRange["LastFullWeek"] = "last-full-week";
    DateRange["LastTwoWeeks"] = "last-two-weeks";
    DateRange["LastFourWeeks"] = "last-four-weeks";
    DateRange["LastEightWeeks"] = "last-eight-weeks";
    DateRange["LastTwelveWeeks"] = "last-twelve-weeks";
    DateRange["Full"] = "full";
    DateRange["Custom"] = "custom";
})(DateRange || (DateRange = {}));
export var SplitBy;
(function (SplitBy) {
    SplitBy["Nothing"] = "nothing";
    SplitBy["OneWeek"] = "one-week";
    SplitBy["FourWeeks"] = "four-weeks";
})(SplitBy || (SplitBy = {}));
export const DateRangeLabels = {
    [DateRange.LastFullWeek]: 'Last full week',
    [DateRange.LastTwoWeeks]: 'Last two weeks',
    [DateRange.LastFourWeeks]: 'Last 4 weeks',
    [DateRange.LastEightWeeks]: 'Last 8 weeks',
    [DateRange.LastTwelveWeeks]: 'Last 12 weeks',
    [DateRange.Full]: 'Total',
    [DateRange.Custom]: 'Custom',
};
export const defaultDateRangeFilters = {
    dateRangeOptions: [
        {
            value: DateRange.LastFullWeek,
            label: DateRangeLabels[DateRange.LastFullWeek],
        },
        {
            value: DateRange.LastFourWeeks,
            label: DateRangeLabels[DateRange.LastFourWeeks],
        },
        {
            value: DateRange.LastTwelveWeeks,
            label: DateRangeLabels[DateRange.LastTwelveWeeks],
        },
        { value: DateRange.Full, label: DateRangeLabels[DateRange.Full] },
    ],
    splitByOptions: [
        { value: SplitBy.Nothing, label: '-' },
        { value: SplitBy.OneWeek, label: 'One Week' },
        { value: SplitBy.FourWeeks, label: 'Month' },
    ],
};
export var DateRangeFormat;
(function (DateRangeFormat) {
    DateRangeFormat["Dates"] = "dates";
    DateRangeFormat["StartDate"] = "start-date";
    DateRangeFormat["StartEndDateMonth"] = "start-end-date-month";
    DateRangeFormat["StartEndDateMonthDash"] = "start-end-date-month-underscore";
    DateRangeFormat["StartDateMonth"] = "start-date-month";
    DateRangeFormat["WeekNumber"] = "week-number";
    DateRangeFormat["Month"] = "month";
})(DateRangeFormat || (DateRangeFormat = {}));
//# sourceMappingURL=Date.js.map